import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type ManageRequisiteProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function ManageRequisitePage({ children, ...props }: ManageRequisiteProps) {
  return (
    <MarkdownPage group={"public"} message={"requisite"} isEditable={true}></MarkdownPage>
  )
}
